/*
  eslint
  no-param-reassign: ["error", { "props": false }]
*/
export default {
  namespaced: true,
  state: {
    view: 'table',
    filterType: 'categories',
    filter: [],
    digitaFilter: true,
  },
  mutations: {
    SET_VIEW(state, view) {
      state.view = view;
    },
    SET_FILTER_TYPE(state, filterType) {
      state.filterType = filterType;
    },
    SET_FILTER(state, filter) {
      state.filter = filter;
    },
    SET_DIGITA_FILTER(state, digitaFilter) {
      state.digitaFilter = digitaFilter;
    },
  },
};
